import { y as head } from "../../../chunks/index2.js";
function _page($$renderer) {
  head("1heqf93", $$renderer, ($$renderer2) => {
    $$renderer2.title(($$renderer3) => {
      $$renderer3.push(`<title>Dokumenty</title>`);
    });
    $$renderer2.push(`<meta name="description" content="Kim jesteśmy i co robimy czyli kilka słów o naszej kancelarii."/>`);
  });
}
export {
  _page as default
};
